import React, { useRef, useState } from "react";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import { Link, useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import { SelectBox } from "../../../../components/DropDown/SelectBox";
import { LuSave } from "react-icons/lu";
import { Icon } from "@iconify-icon/react";
import ToggleButton from "../../../../components/ToggleButton/ToggleButton";
import { toast } from "react-toastify";
import { Axios } from "../../../../components/Helpers/Axios";
import Loading from "../../../../components/Loading/Loading";
import { useEffect } from "react";

const AddPost = () => {
  
  const click = useRef(null);
  const navigate = useNavigate();
  const [laoding, setLoading] = useState();
  const [form, setForm] = useState({
    image: "",
    title: "",
    slug: "",
    category: "",
    description: "",
  });
  const [showHomePage, setShowHomePage] = useState(0);
  const [isPopular, setIsPopular] = useState(0);
  const [status, setStatus] = useState(0);
  const [category , setCategory] = useState([])


  //  get post category
useEffect(()=>{
  Axios.get(`/admin/blog-category`).then(data=>{
    setCategory(data.data.data.data);
//data.data.data.data);
  })
},[])
//form);
const categoryData =  category?.map((data,index)=>(
  
 <option value={data.id}>{data.name}</option>



))
  // handleSubmit function
  const handleSubmit = async (e) => {
    // setLoading(true)
    e.preventDefault();
    //    Form Data
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("image", form.image);
    formData.append("slug", form.slug);
    formData.append("description", form.description);
    formData.append("blog_category_id", form.category);
    formData.append("show_homepage", showHomePage);
    formData.append("status", status);
    formData.append("is_popular", isPopular);
    try {
      setLoading(true);
      if (form.image) {
        const res = await Axios.post("/admin/blogs", formData).then((data) => {
          //data);
          setLoading(false);
          toast.success("Created successfly");
          setTimeout(() => {
            navigate("/admin/post-list");
          }, 2000);
        });
      } else {
        toast.error("image is required");
        setLoading(false);
      }
    } catch (err) {
      toast.error("some thing wrong");
       setLoading(false)
      //err);
    }
  };

  return (
    <div className="UpdateCategory">
      <div className="flex justify-between items-center">
        <h3 className="font-bold text-textColor text-xl"> Add Post</h3>
        <Breadcrumbs />
      </div>
      <div className="bg-white my-8">
        <div className="flex justify-between mb-4 items-center border-b p-4  border-borderColor">
          <h4 className="text-main text-base ">Add Post</h4>
          <button
            onClick={() => navigate(-1)}
            className="flex justify-between gap-1 items-center text-white bg-main py-2 px-4 rounded-md link border border-main duration-500 hover:bg-white hover:text-main"
          >
            <Icon
              icon="solar:arrow-left-outline"
              width={20}
              height={20}
              className="hover:bg-white hover:text-main"
            />
            <span>Back</span>
          </button>
        </div>
        <form className="inputs  p-7" onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
              type="file"
              hidden
              ref={click}
              onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
              required
            />
            <div
              onClick={() => click.current.click()}
              className="cursor-pointer flex justify-end py-2 items-center flex-col gap-1 w-56 h-56 rounded border-spacing-2 border-2 border-dashed border-borderColor"
            >
              {form.image && (
                <img
                  src={URL.createObjectURL(form.image)}
                  width={140}
                  height={120}
                  alt=""
                />
              )}
              <button
                type="button"
                className="text-base text-textColor border border-borderColor py-2 px-8 rounded w-3/4 justify-self-end"
              >
                Icon
              </button>
            </div>
          </div>
          <div className="form-control">
            <label htmlFor="Titel">Title</label>
            <input
              type="text"
              id="Titel"
              value={form.title}
              disabled={laoding}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
            />
          </div>
          <div className="form-control">
            <label htmlFor="slug">Slug</label>
            <input
              type="text"
              id="slug"
              value={form.slug}
              disabled={laoding}
              onChange={(e) => setForm({ ...form, slug: e.target.value })}
              required
            />
          </div>
          <div className="form-control">
            <label htmlFor="category">Category</label>
            <select
            required
              type="text"id="category"
              className="bg-white"
              value={form.category}
              disabled={laoding}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
              
            >
              <option disabled value="">Category</option>
{categoryData}
            </select>
          </div>
          <div className="form-control ">
            <label htmlFor="Description">Description</label>
            <textarea
              type="text"
              id="Description"
              className="h-36"
              disabled={laoding}
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
              required
            />
          </div>

          <div className="toggels mt-4 grid gap-4">
            <ToggleButton title="Show on homepage" setData={setShowHomePage} />
            <ToggleButton title="Mark as populer" setData={setIsPopular} />
            <ToggleButton title="Status" setData={setStatus} />
          </div>
          <button
            disabled={Loading}
            type="submit"
            className={`${laoding && "cursor-wait"}`}
          >
            {laoding ? (
              "Loading..."
            ) : (
              <>
                <LuSave width={24} height={24} className=" text-white icon" />
                <span>Save</span>{" "}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPost;
